import { homeConstant } from "../../../../premium/constants/homeConstant";
import { LocalStorageService } from "../../../../services";
import authHeader from "../../../../services/auth/auth-header";
import UploadFileHeader from "../../../../services/auth/uploadFileHeader";
import { getApi, postApi } from "../../../../services/helpers/apiCall";
import config from "./configComponent.json";
import surveyConfig from "./surveyConfig.json";
import registration01 from "./registration-data-01.json";
import registration02 from "./registration-data-02.json";
import Axios from "axios";
// import registration03 from "./registration-data-03.json";

// action for step 1
const getStartedStep =
  ({ assessmentName, jobType, step }) =>
  (dispatch) => {
    // console.log(assessmentName, "=====> here is assessmentName");
    // console.log(jobType, "=====> here is jobType array");
    dispatch({
      type: homeConstant.GET_STARTED_STEP,
      payload: {
        assessmentName,
        jobType,
        step,
      },
    });
  };

// action for step 2
const chooseAssessment = (data, step) => (dispatch) => {
  // console.log(data, "  =====> here is choose assessmemt Step Data");
  dispatch({
    type: homeConstant.CHOOSE_ASSESSMENTS_STEP,
    payload: {
      data,
      step,
    },
  });
};

// action for step 3
const customizeStep = (data, step) => (dispatch) => {
  // console.log(data, "  =====> here is Customize Step Data");
  dispatch({
    type: homeConstant.CUSTOMIZE_STEP,
    payload: {
      data,
      step,
    },
  });
};

// action for step 4
const configureLaunchStep = (data) => (dispatch) => {
  // console.log(data, "  =====> here is Customize Step Data");
  dispatch({
    type: homeConstant.CONFIGURE_LAUNCH_STEP,
    payload: {
      data,
      step: 4,
    },
  });
};

// Previous Step
const previousStep = (step) => (dispatch) => {
  dispatch({
    type: homeConstant.PREVIOUS_STEP,
    payload: {
      step,
    },
  });
};

const finalStep = (step) => (dispatch) => {
  dispatch({
    type: homeConstant.FINAL_STEP,
    payload: {
      step,
    },
  });
};
const getAllData = (step) => (dispatch) => {
  // let step1 = LocalStorageService.getObject("step1");
  // let step2 = LocalStorageService.getObject("step2");
  // let step3 = LocalStorageService.getObject("step3");
  // let step4 = LocalStorageService.getObject("step4");
  // let allData = {
  //   step1,
  //   step2,
  //   step3,
  //   step4,
  // };
  dispatch({
    type: homeConstant.ASSESSMENT_REPORT,
    payload: {
      // allData,
      step: step,
    },
  });
};

// for navigation
const handleMainTab = () => (dispatch) => {
  dispatch({
    type: homeConstant.BACK_TO_HOME,
    payload: {
      step: 1,
    },
  });
};

// Create Campaign Actions

// Convert Dates

let convert = (str) => {
  var date = new Date(str),
    month = ("0" + Number(date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), month, day].join("-");
};

let getRegistration = (fileds, index, step3) => {
  let regFileds = [registration01, registration02];
  let registration = {
    fields: [],
  };

  let filedsSequence = [
    [
      "Full Name",
      "Email Address",
      "Date Of Birth",
      "Country",
      "City",
      "Gender",
      "Nationality",
      "Identity Number",
      "Phone Number",
      "Address",
      "Health Disability",
    ],
    [
      "Graduation Year",
      "Major Subject",
      "Institute Name",
      "Degree Program",
      "Grading Value",
      "Current Employment",
      "Previous Employment",
      "Area of Interest",
    ],
    // ["Upload CV/Resume"],
  ];

  filedsSequence[index - 1].forEach((info) => {
    if (fileds.includes(info)) {
      let field = regFileds[index - 1][info];
      if (field !== undefined) {
        if (info === "Area of Interest") {
          field["options"] = step3 && step3.areaOfIntrest;
        }
        registration["fields"].push(field);
      }
    }
  });
  return registration;
};

const createCompetencyTower = (campaignId, step2, step3) => {
  let resumeOn =
    step3 && step3.employmentFeilds.indexOf("Upload CV/Resume") !== -1;

  console.log(resumeOn, " here is it");

  var startScenes = [
    {
      type: "SJT",
      title: "",
      description: "",
      componentId: "scene01",
      nextComponentId: "scene02",
      dataURL: "./assets/jsons/scene01.json",
      assetsURL: "./assets/images/campaign/intro/",
      state: "open",
      active: "TRUE",
    },
    {
      type: "SJT",
      title: "",
      description: "",
      componentId: "scene02",
      nextComponentId: "registration",
      dataURL: "./assets/jsons/scene02.json",
      assetsURL: "./assets/images/campaign/intro/",
      state: "open",
      active: "TRUE",
    },
  ];

  var regEndTowerStartId = "scene03";
  var registrations = [
    {
      type: "Registration",
      title: "",
      description: "",
      componentId: "registration",
      nextComponentId: "registration02",
      startupData: `{"vertical": "./assets/images/campaign/registration/About Yourself_M.png","horizontal": "./assets/images/campaign/registration/About Yourself_D.png"}`,
      dataURL: "./assets/jsons/config/registration-data-01.json",
      assetsURL: "./assets/images/campaign/registration/",
      state: "open",
      active: "TRUE",
    },
    {
      type: "Registration",
      title: "",
      description: "",
      componentId: "registration02",
      nextComponentId: resumeOn ? "registration03" : regEndTowerStartId,
      startupData: `{"vertical": "./assets/images/campaign/registration/About Your Experience_M.png","horizontal": "./assets/images/campaign/registration/About Your Experience_D.png"}`,
      dataURL: "./assets/jsons/config/registration-data-02.json",
      assetsURL: "./assets/images/campaign/registration/",
      state: "open",
      active: "TRUE",
      campaignId: "",
    },
  ];

  var registration3 = {
    type: "Registration",
    title: "",
    description: "",
    componentId: "registration03",
    nextComponentId: regEndTowerStartId,
    startupData: `{"vertical": "./assets/images/campaign/registration/Upload Resume_M.png","horizontal": "./assets/images/campaign/registration/Upload Resume_D.png"}`,
    dataURL: "./assets/jsons/config/registration-data-03.json",
    assetsURL: "./assets/images/campaign/registration/",
    state: "open",
    active: "TRUE",
  };

  var towerStart = [
    {
      type: "SJT", // SJT TOWER Start
      title: "",
      description: "",
      componentId: regEndTowerStartId,
      nextComponentId: "task-center",
      dataURL: "./assets/jsons/scene03.json",
      assetsURL: "./assets/images/campaign/intro/",
      state: "open",
      active: "TRUE",
      campaignId: "",
    },
    {
      type: "COMPETENCY_SELECTION_SCREEN",
      title: "",
      description: "",
      componentId: "task-center",
      nextComponentId: "game-end",
      startupData: [],
      assetsURL: "undefined",
      state: "open",
      active: "TRUE",
      campaignId: "",
    },
  ];

  var CompetencyTower = [];

  var towerGameEnd = {
    type: "SJT",
    title: "",
    description: "",
    componentId: "game-end",
    nextComponentId: -1,
    dataURL: "./assets/jsons/game-end.json",
    assetsURL: "./assets/images/campaign/intro/",
    state: "open",
    active: "TRUE",
  };

  CompetencyTower = [];
  let apiCallRequest;

  // Start Adding Initial Scenes

  startScenes.forEach(async (item) => {
    item.campaignId = campaignId;
    console.log("initial Scenes", item);
    apiCallRequest = {
      url: "/competencies", // getCompaniesInfo
      data: item,
      config: {
        headers: authHeader(),
      },
    };
    CompetencyTower.push(apiCallRequest);
  });

  // End Adding Initial Scenes

  // Start Adding Registration

  registrations.forEach(async (item) => {
    item.campaignId = campaignId;
    console.log("Registration", item);
    apiCallRequest = {
      url: "/competencies", // getCompaniesInfo
      data: item,
      config: {
        headers: authHeader(),
      },
    };

    CompetencyTower.push(apiCallRequest);
  });

  if (resumeOn) {
    registration3.campaignId = campaignId;
    apiCallRequest = {
      url: "/competencies", // getCompaniesInfo
      data: registration3,
      config: {
        headers: authHeader(),
      },
    };
    CompetencyTower.push(apiCallRequest);
  }

  // End Adding Registration

  // Start Adding Tower

  towerStart.forEach(async (item) => {
    item.campaignId = campaignId;
    if (item.type === "COMPETENCY_SELECTION_SCREEN") {
      console.log(step2.allCompetencies);
      step2 &&
        step2.allCompetencies.forEach((towerItem) => {
          item.startupData.push(towerItem.componentId);
        });

      item.startupData = JSON.stringify(item.startupData);
    }

    apiCallRequest = {
      url: "/competencies", // getCompaniesInfo
      data: item,
      config: {
        headers: authHeader(),
      },
    };

    CompetencyTower.push(apiCallRequest);
  });

  // End Adding Tower

  // start Adding Competencies process

  // towerCompetencyData - competencyOject Array
  step2 &&
    step2.allCompetencies.forEach(async (item) => {
      item.campaignId = campaignId;
      console.log("competencyData", item);

      apiCallRequest = {
        url: "/competencies",
        data: item,
        config: {
          headers: authHeader(),
        },
      };

      CompetencyTower.push(apiCallRequest);
    });
  // End Adding Competencies process

  // Start Adding Tower End Scene
  towerGameEnd.campaignId = campaignId;
  apiCallRequest = {
    url: "/competencies", // getCompaniesInfo
    data: towerGameEnd,
    config: {
      headers: authHeader(),
    },
  };
  CompetencyTower.push(apiCallRequest);

  return CompetencyTower;
};

const createApiCallRequestsForImages = async (bucketName, campaignImages) => {
  const apiCallRequests = [];
  for (let i = 0; i < campaignImages.length; i++) {
    const campaignImage = campaignImages[i];
    if (campaignImage.url && campaignImage.file) {
      const base64 = campaignImage.file;
      const fd = new FormData();
      const blob = await fetch(base64).then((res) => res.blob());
      const file = new File([blob], campaignImage.url + ".png");
      fd.append("file", file, file.name);
      const apiCallRequest = {
        url: `gcp/upload/${bucketName}/${campaignImage.url}`,
        data: fd,
        config: {
          headers: UploadFileHeader(fd),
        },
      };

      apiCallRequests.push(apiCallRequest);
    }
  }

  return apiCallRequests;
};

const getRegistrationApiCall = (step3, bucketName) => {
  let personalInFeilds = step3 && step3.personalInFeilds;
  let academicFeilds =
    step3 && step3.academicFeilds.concat(step3 && step3.employmentFeilds);
  if (step3 && step3.areaOfIntrest.length > 0)
    academicFeilds.push("Area of Interest");
  let fileRegistration01 = getRegistration(personalInFeilds, 1, step3);
  let fileRegistration02 = getRegistration(academicFeilds, 2, step3);

  // let fileRegistration03 = getRegistration(employmentFeilds, 2, step3);
  console.log(fileRegistration01, " ===> getRegistration01");
  console.log(fileRegistration02, " ===> getRegistration02");
  let apiCallRequestFileRegistration1 = {
    url: `/gcp/uploadfile/${bucketName}/1`,
    data: fileRegistration01,
    config: {
      headers: authHeader(),
    },
  };
  let apiCallRequestFileRegistration2 = {
    url: `/gcp/uploadfile/${bucketName}/2`,
    data: fileRegistration02,
    config: {
      headers: authHeader(),
    },
  };
  let finalJson = [
    apiCallRequestFileRegistration1,
    apiCallRequestFileRegistration2,
  ];

  return finalJson;
};
const createCompleteCampaign = (data) => (dispatch) => {
  let step1 = data && data.step1Data;
  let step2 = data && data.step2Data;
  let step3 = data && data.step3Data;
  let step4 = data && data.step4Data;

  let bucketName =
    step1 && step1.assessmentName.toLowerCase().replace(/[^A-Za-z0-9]/g, "");

  // Get Client By User ID Start
  let userData = LocalStorageService.getObject("client");

  let apiCallRequest = {
    url: `/clients/byuserid/` + userData.userId,
    data: {},
    config: {
      headers: authHeader(),
    },
  };

  let campaignId;
  var intervalId;
  getApi(apiCallRequest)
    .then((resp) => {
      let clientId = resp.data.id;
      let apiCallRequest = {
        url: `/campaigns`,
        data: {
          startupComponentId: 1,
          name: step1 && step1.assessmentName,
          title: step1 && step1.assessmentName,
          description: step1 && step1.assessmentName,
          start_date: convert(step4 && step4.launchDate),
          end_date: convert(step4 && step4.closingDate),
          active: true,
          clientId: clientId,
          campaignUrl: bucketName,
          campaignEmail: "support@thetalentgames.com",
          emailSubject: `Assessment invitation to the ${
            step1 && step1.assessmentName
          } Talent Games`,
          emailTemplate: `<p><strong>Dear Candidate,</strong></p>
          <p>&nbsp;</p>
          <p>You are now required to attempt an exciting online assessment in the form of an interactive game.</p>
          <p>&nbsp;</p>
          <p>To attempt the online assessment, please click on the link below. You must complete the assessment within 3 calendar days from the date of this email, following which the link will expire.</p>
          <p>&nbsp;</p>
          <a href="https://${bucketName}.thetalent.games" target=""_blank"">https://${bucketName}.thetalent.games</a>
          <p><br></p>
          <p>For any queries related to the assessment, please email&nbsp;<a rel=""noopener noreferrer"" target=""_blank"">support@thetalentgames.com</a>. We wish you all the best for your application.</p>
          <p>&nbsp;</p>
          <p>Regards,</p>
          <p>Talent Acquisition team</p>
          <p>TheTalentGames</p>`,
        },
        config: {
          headers: authHeader(),
        },
      };
      dispatch(request("Creating assessment game, please wait...."));
      return postApi(apiCallRequest);
    })
    .then((response) => {
      dispatch(request("Assessment game created!"));
      campaignId = response.data.id;
      LocalStorageService.set("campaignId", campaignId);
      LocalStorageService.set("bucketName", bucketName);
      dispatch(request("Configuring your settings, please wait...."));
      console.log(
        step4 && step4.showCandidateSurvey,
        "===> here is survey value"
      );
      // API Config Start
      var apiConfigCallRequest = {
        url: `/campaigns/${campaignId}/config`,
        data: {
          linkedInLogin:
            step3 && step3.loginMethod === "linkedLogin" ? true : false,
          enableFaceRecognition:
            step4 && step4.facialRecognition ? true : false,
          faceRecognitionTimer: 5000,
          tabChangeLock: step4 && step4.gameAutoLock ? true : false,
          logging: true,
          apiEncryption: false,
          sessionsLock: step4 && step4.gameAutoLock ? true : false,
          components:
            step4 && step4.showCandidateSurvey
              ? JSON.stringify(surveyConfig)
              : JSON.stringify(config),
          sessionsAllowed: 3,
          linkExpiryLock: false,
          faceRecognitionWarnings: 3,
          tabChangeWarnings: 3,
        },
        config: {
          headers: authHeader(),
        },
      };
      return postApi(apiConfigCallRequest);
    })
    .then((configResponse) => {
      dispatch(success("Configuring done!"));
      return createCompetencyTower(campaignId, step2, step3);
    })
    .then(async (res) => {
      let towerList = res;
      for (let i = 0; i < towerList.length; i++) {
        dispatch(request("Adding - " + towerList[i].data.componentId));
        await postApi(towerList[i]);
        dispatch(success("Successfully added assessments games."));
      }
    })
    .then(() => {
      // Initialize progress messages
      const progressMessages = [
        "You are about to create something great.....",
        "Your gamified test is coming together.....",
        "Our system is working........",
        "Putting together all assessments you have chosen......",
        "Almost there..........",
        "Creating game URL, please wait.....",
        "75% Done!",
        "90% Done!",
        "Almost there..........",
      ];
      let currentMessageIndex = 0;
      intervalId = setInterval(() => {
        dispatch(request(progressMessages[currentMessageIndex]));
        currentMessageIndex =
          (currentMessageIndex + 1) % progressMessages.length;
      }, 6000);

      const apiCallRequestCreateBucket = {
        url: `/gcp/createBucket/${bucketName}/${campaignId}`,
        data: {},
        config: {
          headers: authHeader(),
        },
      };
      return postApi(apiCallRequestCreateBucket);
    })
    .then(async () => {
      clearInterval(intervalId);
      dispatch(request("Successfully created game URL!"));
      let campaignImages = await createApiCallRequestsForImages(
        bucketName,
        step3 && step3.images
      );
      for (let i = 0; i < campaignImages.length; i++) {
        dispatch(request("Adding assets please wait "));
        const response = await postApi(campaignImages[i]);
        dispatch(success("Successfully added assets!"));
      }
    })
    .then(async () => {
      dispatch(request("Adding registration files!"));
      let jsonApiCalls = await getRegistrationApiCall(step3, bucketName);
      for (let i = 0; i < jsonApiCalls.length; i++) {
        const response = await postApi(jsonApiCalls[i]);
        dispatch(success("Successfully added registration "));
      }
    })
    .then((res) => {
      success("And it's done! Your gamified test is created.");
      let apiCallRequest = {
        url: `/tags`,
        data: {
          tags: ["Top Candidates"],
          campaignId,
        },
        config: {
          headers: authHeader(),
        },
      };

      return postApi(apiCallRequest);
    })
    .then(() => {
      dispatch(success("Game Live Link", bucketName, campaignId));
      LocalStorageService.remove("step1");
      LocalStorageService.remove("step2");
      LocalStorageService.remove("step3");
      LocalStorageService.remove("step4");
      LocalStorageService.remove("campaignId");
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function request(message) {
    return {
      type: homeConstant.ADD_CAMPAIGN_NAME_REQUEST,
      payload: {
        message,
      },
    };
  }

  function success(message, bucketName, campaignId) {
    return {
      type: homeConstant.ADD_CAMPAIGN_NAME,
      payload: {
        message,
        bucketName,
        campaignId,
      },
    };
  }
  function failure(error) {
    return {
      type: homeConstant.ADD_CAMPAIGN_NAME_ERROR,
      payload: {
        message: error,
      },
    };
  }
};

const validateInvitaion = async (campaignId) => {
  try {
    const { data } = await getApi({
      url: `/auth/campaign/config/${campaignId}`,
      data: {},
      config: {
        headers: authHeader(),
      },
    });

    const limit = data.components[0]?.saas.invitationLimit;

    const {
      data: { total },
    } = await postApi({
      url: `/mail/users/${campaignId}/1`,
      data: {
        sortBy: "email",
        sortDirection: "desc",
        searchQuery: "",
        perpage: 0,
      },
      config: {
        headers: authHeader(),
      },
    });

    return limit - total;
  } catch (err) {
    console.error(err);
  }
};

// single invite
let sendSingleInvite = (email, campaignId) => async (dispatch) => {
  dispatch(request("Please Wait..."));
  let count = await validateInvitaion(campaignId);
  if (count !== 0) {
    let apiCallRequest = {
      url: `/mail/sendinvite/${campaignId}`,
      data: {
        email,
      },
      config: {
        headers: authHeader(),
      },
    };

    postApi(apiCallRequest)
      .then(async (res) => {
        let mainCount = await validateInvitaion(campaignId);
        dispatch(success(`Invitation sent, remaining: ${mainCount}`));
        setTimeout(() => {
          dispatch(success(""));
        }, 7000);
      })
      .catch((err) => {
        dispatch(failure(err.message));
      });
  } else {
    dispatch(failure("Limit Reached!"));
  }

  function request(message) {
    return {
      type: homeConstant.SEND_SINGLE_INVITE_REQUEST,
      payload: {
        message,
      },
    };
  }

  function success(message) {
    return {
      type: homeConstant.SEND_SINGLE_INVITE,
      payload: {
        message,
      },
    };
  }
  function failure(error) {
    return {
      type: homeConstant.SEND_SINGLE_INVITE_ERROR,
      payload: {
        message: error,
      },
    };
  }
};

// Unlock Game

let bulkInvites = (campaignId, usersEmails) => async (dispatch) => {
  let mainCount = await validateInvitaion(campaignId);
  if (mainCount !== 0) {
    let page = 0;
    let count = usersEmails.length - 1;

    dispatch(request("Please Wait..."));

    async function loop(page) {
      // This would be the POST request
      let apiCallRequest = {
        url: `/mail/sendinvite/${campaignId}`,
        data: {
          email: usersEmails[page].name,
        },
        config: {
          headers: authHeader(),
        },
      };

      let promise = new Promise((resolve, reject) => {
        postApi(apiCallRequest)
          .then((response) => {
            if (response.status) {
              resolve("done!");
            }
          })
          .catch((error) => {
            reject("failed!");
            dispatch(failure("Failed to invite!"));
          });
      });

      await promise;

      if (page < count) {
        await loop(page + 1);
      }
    }

    await loop(page);
    let remaining = await validateInvitaion(campaignId);
    dispatch(success(`Invitations sent, remaining: ${remaining}`));
    setTimeout(() => {
      dispatch(success(``));
    }, 7000);
  } else {
    dispatch(failure("Failed to invite!"));
  }

  function request(message) {
    return {
      type: homeConstant.SEND_BULK_INVITE_REQUEST,
      payload: {
        message,
      },
    };
  }

  function success(message) {
    return {
      type: homeConstant.SEND_BULK_INVITE,
      payload: {
        message,
      },
    };
  }
  function failure(error) {
    return {
      type: homeConstant.SEND_BULK_INVITE_ERROR,
      payload: {
        message: error,
      },
    };
  }
};

let sendSupportQuery = (data) => async (dispatch) => {
  dispatch(request("Please Wait..."));
  let apiCallRequest = {
    url: "https://backendpaygo.thetalent.games/gcp/sendcontactform",
    data: data,
    config: {
      headers: authHeader(),
    },
  };

  Axios.post(apiCallRequest.url, apiCallRequest.data, apiCallRequest.config)
    .then((res) => {
      dispatch(success("Support email sent successfully!"));
      setTimeout(() => {
        dispatch(success(false));
      }, 2000);
    })
    .catch((er) => {
      dispatch(failure(er.message));
    });

  function request(message) {
    return {
      type: homeConstant.SEND_SUPPORT_EMAIL_REQUEST,
      payload: {
        message,
      },
    };
  }

  function success(message) {
    return {
      type: homeConstant.SEND_SUPPORT_EMAIL,
      payload: {
        message,
      },
    };
  }
  function failure(error) {
    return {
      type: homeConstant.SEND_SUPPORT_ERROR,
      payload: {
        message: error,
      },
    };
  }
};



let saveTemplate = (campaignId, settings) => async (dispatch) => {
  let { emailTemplate, emailSubject, campaignEmail } = settings;
  dispatch(request("Please Wait..."));
  let apiCallRequest = {
    url: `/campaigns/${campaignId}`,
    data: {
      campaignEmail,
      emailSubject,
      emailTemplate,
    },
    config: {
      headers: authHeader(),
    },
  };
  postApi(apiCallRequest)
    .then((resp) => {
      dispatch(success("Template Updated!"));

      setTimeout(() => {
        dispatch(success(""));
      }, 3000);
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function request(message) {
    return {
      type: homeConstant.GET_EMAIL_TEMPLATE_REQUEST,
      payload: {
        message,
      },
    };
  }

  function success(message) {
    return {
      type: homeConstant.GET_SUCCESS_EMAIL_TEMPLATE,
      payload: {
        message,
      },
    };
  }
  function failure(error) {
    return {
      type: homeConstant.GET_EMAIL_TEMPLATE_ERROR,
      payload: {
        message: error,
      },
    };
  }
};

export {
  getStartedStep,
  customizeStep,
  configureLaunchStep,
  previousStep,
  getAllData,
  handleMainTab,
  chooseAssessment,
  finalStep,
  createCompleteCampaign,
  sendSingleInvite,
  bulkInvites,
  validateInvitaion,
  sendSupportQuery,
  saveTemplate
};
